// extracted by mini-css-extract-plugin
module.exports = {"separator":"_rw","finalPrice":"_rx"};